/**
 * Currency fix - Philip Lloyd Jewellers
 *
 * PROBLEM
 * assets/theme.js formats client-side prices with a hardcoded format:
 *    store.currency  -> var moneyFormat = '${{amount}}';
 *    setChosenPrice  -> var f = '£{{amount}}';
 *
 * Under Shopify Markets, /products/<handle>.js returns PRESENTMENT prices.
 * Every ring has variant options, so productPage.init() fires a change event
 * on page load and setChosenPrice() overwrites the correctly rendered price.
 * A Philippines visitor therefore saw "£1,000,700.00" on an £11,950 ring.
 *
 * FIX
 * Force formatMoney to use the active presentment money format, which
 * header-common.liquid renders into window.themeMoneyFormat from
 * shop.money_format ("£{{amount}}" for GB, "₱{{amount}}" for PH, etc).
 *
 * TIMING
 * Loaded deferred immediately AFTER theme.js. Deferred scripts run in order,
 * and productPage.init() suspends on a network fetch, so this override is
 * always installed before setChosenPrice() can run.
 *
 * PERMANENT FIX
 * Replace the two hardcoded formats in assets/theme.js with
 * window.themeMoneyFormat, then delete this file and its script tag.
 */
(function () {
   var fmt = window.themeMoneyFormat;

   if (!fmt || !window.store || !store.currency || !store.currency.formatMoney) {
      return;
   }

   var original = store.currency.formatMoney;

   store.currency.formatMoney = function (cents, format) {
      return original(cents, fmt);
   };
})();
